import React, { useState } from "react";
import {
  IconButton,
  Snackbar,
  Alert,
  Tooltip,
  Avatar,
  Chip,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import DoneAllIcon from "@mui/icons-material/DoneAll";

function ExamCardView1({ loading, SelectedTest, setSelectedTest, Testall }) {
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  //--------------------------------------------------------------------------------
  // Function to handle the selection of a question
  //--------------------------------------------------------------------------------
  const handleAddQuestion = (question) => {
    if (SelectedTest.includes(question)) {
      // If the question is already selected, remove it from selectedQuestions
      setSelectedTest((prevSelected) =>
        prevSelected.filter((q) => q !== question)
      );
    } else {
      // If it's not selected, add it to the top of selectedQuestions and show Snackbar
      setSelectedTest((prevSelected) => [question, ...prevSelected]); // Add to the top
      setSnackbarOpen(true); // Open Snackbar
    }
  };

  //--------------------------------------------------------------------------------
  // Handle the "Done" action to move the question to the top
  //--------------------------------------------------------------------------------
  const handleMarkAsDone = (question) => {
    setSelectedTest((prevSelected) => {
      // Remove the question from the current position
      const updatedSelected = prevSelected.filter((q) => q !== question);
      // Add it back at the top
      return [question, ...updatedSelected];
    });
  };

  //--------------------------------------------------------------------------------
  // Handle closing the Snackbar
  //--------------------------------------------------------------------------------
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  // Sort rows to bring selected questions to the top
  // Sort rows to bring selected questions to the top
  // const sortedRows = Array.isArray(rows) && rows.length > 0
  //   ? [...rows].sort((a, b) => {
  //       const isASelected = selectedQuestions.includes(a);
  //       const isBSelected = selectedQuestions.includes(b);
  //       return isASelected === isBSelected ? 0 : isASelected ? -1 : 1;
  //     })
  //   : []; // Return an empty array if rows is empty or not an array

  return (
    <>
      <div>
        <div className="accordion-container-add-totest">
          {Testall &&
            Testall.map((Test, index) => (
              <div
                key={index}
                className="all-component-render-page-outer-container"
              >
                <div className="accordion-summary-of-the-question-display-instructor-card">
                  <Tooltip
                    title={`State/Department: ${Test.state_or_department}`}
                    arrow
                  >
                    <Avatar className="studentview1-avatar-bakground-color">
                      {Test.exam_name.charAt(0).toUpperCase()}
                    </Avatar>
                  </Tooltip>
                  <div className="username-and-phonenumber-alignmnet">
                    <div>{Test.exam_name}</div>
                    <div className="Testcardview1-general-info-alignemnt">
                      <div>
                        <span className="font-weight-reduce-and-alignment">
                          Exam Category:
                        </span>
                        <span className="Test-card-view1-text-color">
                          &nbsp;{Test.exam_category}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  {/* Expanded details for each question */}
                  <div>
                    <div className="add-icon-and-right-icon-placement">
                      <Chip
                        className="difficulty-level-shown-color-font-test-card-view"
                        label={Test.top_category}
                        style={{
                          backgroundColor:
                            Test.top_category === "State"
                              ? "green"
                              : Test.top_category === "Central"
                              ? "rgb(176, 74, 227)" // Assuming 'Central' category is blue
                              : Test.top_category === "Department"
                              ? "orange"
                              : "gray", // Default color if no condition matches
                        }}
                      />
                      {SelectedTest.includes(Test) ? (
                        <Tooltip title="Navigate the Exams " arrow>
                          <IconButton
                            className="icon-button-to-disapay-done-button"
                            onClick={() => handleMarkAsDone(Test)} // Mark as done
                          >
                            <DoneAllIcon />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <Tooltip title="Add Examss to Batch" arrow>
                          <IconButton
                            className="icon-button-to-disapay-add-button"
                            onClick={() => handleAddQuestion(Test)}
                          >
                            <Add />
                          </IconButton>
                        </Tooltip>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
      {/* __________________snackbar notification_____________*/}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={500}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert severity="success">Exams added to Batch successfully!</Alert>
      </Snackbar>
    </>
  );
}

export default ExamCardView1;
